import _definePage_default_0 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/customers/index.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/dashboard/index.vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/kiosks/index.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/live-dashboard/index.vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/locations/index.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/sessions/index.vue?definePage&vue'
import _definePage_default_8 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/traffic/index.vue?definePage&vue'
import _definePage_default_9 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/visiting-rules/index.vue?definePage&vue'
import _definePage_default_10 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/common/notifications/index.vue?definePage&vue'
import _definePage_default_11 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/action-hub/index.vue?definePage&vue'
import _definePage_default_12 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/auth/role.vue?definePage&vue'
import _definePage_default_13 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/capa-management.vue?definePage&vue'
import _definePage_default_14 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/customer-communication.vue?definePage&vue'
import _definePage_default_15 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/index.vue?definePage&vue'
import _definePage_default_16 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/complaint.vue?definePage&vue'
import _definePage_default_17 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/department/index.vue?definePage&vue'
import _definePage_default_18 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/feedback.vue?definePage&vue'
import _definePage_default_19 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/location/index.vue?definePage&vue'
import _definePage_default_20 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/preference/index.vue?definePage&vue'
import _definePage_default_21 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/question/index.vue?definePage&vue'
import _definePage_default_22 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/rca.vue?definePage&vue'
import _definePage_default_23 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/ticket.vue?definePage&vue'
import _definePage_default_24 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/unit/index.vue?definePage&vue'
import _definePage_default_25 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/index.vue?definePage&vue'
import _definePage_default_26 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/ward-round.vue?definePage&vue'
import _definePage_default_27 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/ward-round-v2.vue?definePage&vue'
import _definePage_default_28 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/episode.vue?definePage&vue'
import _definePage_default_29 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/feedback-history.vue?definePage&vue'
import _definePage_default_30 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/feedback-panel.vue?definePage&vue'
import _definePage_default_31 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/category.vue?definePage&vue'
import _definePage_default_32 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/config.vue?definePage&vue'
import _definePage_default_33 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/form-type.vue?definePage&vue'
import _definePage_default_34 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/source.vue?definePage&vue'
import _definePage_default_35 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/tag.vue?definePage&vue'
import _definePage_default_36 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/team.vue?definePage&vue'
import _definePage_default_37 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/not-authorized.vue?definePage&vue'
import _definePage_default_38 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/preference/index.vue?definePage&vue'
import _definePage_default_39 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/preference/[id].vue?definePage&vue'
import _definePage_default_40 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/questionnaire/index.vue?definePage&vue'
import _definePage_default_41 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/questionnaire/group.vue?definePage&vue'
import _definePage_default_42 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/second-page.vue?definePage&vue'
import _definePage_default_43 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/sentiment/index.vue?definePage&vue'
import _definePage_default_44 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/index.vue?definePage&vue'
import _definePage_default_45 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/board.vue?definePage&vue'
import _definePage_default_46 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/compliment.vue?definePage&vue'
import _definePage_default_47 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/utility/qrcode.vue?definePage&vue'
import _definePage_default_48 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/ForgotPassword.vue?definePage&vue'
import _definePage_default_49 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/config/index.vue?definePage&vue'
import _definePage_default_50 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/escalation/index.vue?definePage&vue'
import _definePage_default_51 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/holiday-calender/index.vue?definePage&vue'
import _definePage_default_52 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/department.vue?definePage&vue'
import _definePage_default_53 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/location.vue?definePage&vue'
import _definePage_default_54 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/location-type.vue?definePage&vue'
import _definePage_default_55 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/unit.vue?definePage&vue'
import _definePage_default_56 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/email.vue?definePage&vue'
import _definePage_default_57 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/sms.vue?definePage&vue'
import _definePage_default_58 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/whatsapp.vue?definePage&vue'
import _definePage_default_59 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/users/index.vue?definePage&vue'
import _definePage_default_60 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/audit/index.vue?definePage&vue'
import _definePage_default_61 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/capa/index.vue?definePage&vue'
import _definePage_default_62 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/capa-calender.vue?definePage&vue'
import _definePage_default_63 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/dashboard/index.vue?definePage&vue'
import _definePage_default_64 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/index.vue?definePage&vue'
import _definePage_default_65 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/entry/index.vue?definePage&vue'
import _definePage_default_66 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/entry/view.vue?definePage&vue'
import _definePage_default_67 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/audit/index.vue?definePage&vue'
import _definePage_default_68 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/category.vue?definePage&vue'
import _definePage_default_69 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/contributory-factor.vue?definePage&vue'
import _definePage_default_70 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/fishbone-category.vue?definePage&vue'
import _definePage_default_71 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/incident-category.vue?definePage&vue'
import _definePage_default_72 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/investigation-group.vue?definePage&vue'
import _definePage_default_73 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/question/index.vue?definePage&vue'
import _definePage_default_74 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/question/entry.vue?definePage&vue'
import _definePage_default_75 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/tag.vue?definePage&vue'
import _definePage_default_76 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/type.vue?definePage&vue'
import _definePage_default_77 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/rca/index.vue?definePage&vue'
import _definePage_default_78 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/rca/view.vue?definePage&vue'
import _definePage_default_79 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/login.vue?definePage&vue'
import _definePage_default_80 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/not-authorized.vue?definePage&vue'
import _definePage_default_81 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/panel.vue?definePage&vue'
import _definePage_default_82 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/ResetPassword.vue?definePage&vue'
import _definePage_default_83 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/dashboard.vue?definePage&vue'
import _definePage_default_84 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/master/task.vue?definePage&vue'
import _definePage_default_85 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/ticket-management/index.vue?definePage&vue'
import _definePage_default_86 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/utility/qrcode.vue?definePage&vue'
import _definePage_default_87 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/customer/index.vue?definePage&vue'
import _definePage_default_88 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/customer/view.vue?definePage&vue'
import _definePage_default_89 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/view.vue?definePage&vue'
import _definePage_default_90 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/index.vue?definePage&vue'
import _definePage_default_91 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/analytics.vue?definePage&vue'
import _definePage_default_92 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/setup.vue?definePage&vue'
import _definePage_default_93 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/subscriptions.vue?definePage&vue'
import _definePage_default_94 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/dashboard/index.vue?definePage&vue'
import _definePage_default_95 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/employee/index.vue?definePage&vue'
import _definePage_default_96 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/event/index.vue?definePage&vue'
import _definePage_default_97 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/ticket-management/index.vue?definePage&vue'
import _definePage_default_98 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/two-step.vue?definePage&vue'
import _definePage_default_99 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/care-visit/visitor/pass.vue?definePage&vue'
import _definePage_default_100 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/documentation/[...slug].vue?definePage&vue'
import _definePage_default_101 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/feedback-collect/index.vue?definePage&vue'
import _definePage_default_102 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/service-desk/index.vue?definePage&vue'
import _definePage_default_103 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/service-desk/chat.vue?definePage&vue'
import _definePage_default_104 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/survey-collect/index.vue?definePage&vue'
import _definePage_default_105 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/visitor-pass/[code].vue?definePage&vue'
import _definePage_default_106 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/visitor-registration/index.vue?definePage&vue'
import _definePage_default_107 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/wecarexm-ai/index.vue?definePage&vue'

export const routes = [
  {
    path: '/app',
    /* internal name: 'app' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':error(.*)',
        name: 'app$error',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/[...error].vue'),
        /* no children */
      },
  _definePage_default_0
  ),
      {
        path: 'care-visit',
        /* internal name: 'app-care-visit' */
        /* no component */
        children: [
          {
            path: 'customers',
            /* internal name: 'app-care-visit-customers' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-customers',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/customers/index.vue'),
                /* no children */
              },
  _definePage_default_2
  )
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'app-care-visit-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-dashboard',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_3
  )
            ],
          },
          {
            path: 'kiosks',
            /* internal name: 'app-care-visit-kiosks' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-kiosks',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/kiosks/index.vue'),
                /* no children */
              },
  _definePage_default_4
  )
            ],
          },
          {
            path: 'live-dashboard',
            /* internal name: 'app-care-visit-live-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-live-dashboard',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/live-dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_5
  ),
              {
                path: 'kiosk-analytics',
                name: 'app-care-visit-live-dashboard-kiosk-analytics',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/live-dashboard/kiosk-analytics.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'locations',
            /* internal name: 'app-care-visit-locations' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-locations',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/locations/index.vue'),
                /* no children */
              },
  _definePage_default_6
  )
            ],
          },
          {
            path: 'sessions',
            /* internal name: 'app-care-visit-sessions' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-sessions',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/sessions/index.vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          },
          {
            path: 'traffic',
            /* internal name: 'app-care-visit-traffic' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-traffic',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/traffic/index.vue'),
                /* no children */
              },
  _definePage_default_8
  )
            ],
          },
          {
            path: 'visiting-rules',
            /* internal name: 'app-care-visit-visiting-rules' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-visiting-rules',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/care-visit/visiting-rules/index.vue'),
                /* no children */
              },
  _definePage_default_9
  )
            ],
          }
        ],
      },
      {
        path: 'common',
        /* internal name: 'app-common' */
        /* no component */
        children: [
          {
            path: 'notifications',
            /* internal name: 'app-common-notifications' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-common-notifications',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/common/notifications/index.vue'),
                /* no children */
              },
  _definePage_default_10
  )
            ],
          }
        ],
      },
      {
        path: 'feedback',
        /* internal name: 'app-feedback' */
        /* no component */
        children: [
          {
            path: 'action-hub',
            /* internal name: 'app-feedback-action-hub' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-action-hub',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/action-hub/index.vue'),
                /* no children */
              },
  _definePage_default_11
  )
            ],
          },
          {
            path: 'auth',
            /* internal name: 'app-feedback-auth' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'role',
                name: 'app-feedback-auth-role',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/auth/role.vue'),
                /* no children */
              },
  _definePage_default_12
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'capa-management',
            name: 'app-feedback-capa-management',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/capa-management.vue'),
            /* no children */
          },
  _definePage_default_13
  ),
  _mergeRouteRecord(
          {
            path: 'customer-communication',
            name: 'app-feedback-customer-communication',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/customer-communication.vue'),
            /* no children */
          },
  _definePage_default_14
  ),
          {
            path: 'dashboard',
            /* internal name: 'app-feedback-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-dashboard',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_15
  ),
  _mergeRouteRecord(
              {
                path: 'complaint',
                name: 'app-feedback-dashboard-complaint',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/complaint.vue'),
                /* no children */
              },
  _definePage_default_16
  ),
              {
                path: 'department',
                /* internal name: 'app-feedback-dashboard-department' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-department',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/department/index.vue'),
                    /* no children */
                  },
  _definePage_default_17
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'feedback',
                name: 'app-feedback-dashboard-feedback',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/feedback.vue'),
                /* no children */
              },
  _definePage_default_18
  ),
              {
                path: 'location',
                /* internal name: 'app-feedback-dashboard-location' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-location',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/location/index.vue'),
                    /* no children */
                  },
  _definePage_default_19
  )
                ],
              },
              {
                path: 'preference',
                /* internal name: 'app-feedback-dashboard-preference' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-preference',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/preference/index.vue'),
                    /* no children */
                  },
  _definePage_default_20
  )
                ],
              },
              {
                path: 'question',
                /* internal name: 'app-feedback-dashboard-question' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-question',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/question/index.vue'),
                    /* no children */
                  },
  _definePage_default_21
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'rca',
                name: 'app-feedback-dashboard-rca',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/rca.vue'),
                /* no children */
              },
  _definePage_default_22
  ),
  _mergeRouteRecord(
              {
                path: 'ticket',
                name: 'app-feedback-dashboard-ticket',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/ticket.vue'),
                /* no children */
              },
  _definePage_default_23
  ),
              {
                path: 'unit',
                /* internal name: 'app-feedback-dashboard-unit' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-unit',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/dashboard/unit/index.vue'),
                    /* no children */
                  },
  _definePage_default_24
  )
                ],
              }
            ],
          },
          {
            path: 'empty',
            name: 'app-feedback-empty',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/empty.vue'),
            /* no children */
          },
          {
            path: 'entry',
            /* internal name: 'app-feedback-entry' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-entry',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/index.vue'),
                /* no children */
              },
  _definePage_default_25
  ),
  _mergeRouteRecord(
              {
                path: 'ward-round',
                name: 'app-feedback-entry-ward-round',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/ward-round.vue'),
                /* no children */
              },
  _definePage_default_26
  ),
  _mergeRouteRecord(
              {
                path: 'ward-round-v2',
                name: 'app-feedback-entry-ward-round-v2',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/entry/ward-round-v2.vue'),
                /* no children */
              },
  _definePage_default_27
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'episode',
            name: 'app-feedback-episode',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/episode.vue'),
            /* no children */
          },
  _definePage_default_28
  ),
  _mergeRouteRecord(
          {
            path: 'feedback-history',
            name: 'app-feedback-feedback-history',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/feedback-history.vue'),
            /* no children */
          },
  _definePage_default_29
  ),
  _mergeRouteRecord(
          {
            path: 'feedback-panel',
            name: 'app-feedback-feedback-panel',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/feedback-panel.vue'),
            /* no children */
          },
  _definePage_default_30
  ),
          {
            path: 'master',
            /* internal name: 'app-feedback-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'category',
                name: 'app-feedback-master-category',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/category.vue'),
                /* no children */
              },
  _definePage_default_31
  ),
  _mergeRouteRecord(
              {
                path: 'config',
                name: 'app-feedback-master-config',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/config.vue'),
                /* no children */
              },
  _definePage_default_32
  ),
  _mergeRouteRecord(
              {
                path: 'form-type',
                name: 'app-feedback-master-form-type',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/form-type.vue'),
                /* no children */
              },
  _definePage_default_33
  ),
  _mergeRouteRecord(
              {
                path: 'source',
                name: 'app-feedback-master-source',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/source.vue'),
                /* no children */
              },
  _definePage_default_34
  ),
  _mergeRouteRecord(
              {
                path: 'tag',
                name: 'app-feedback-master-tag',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/tag.vue'),
                /* no children */
              },
  _definePage_default_35
  ),
  _mergeRouteRecord(
              {
                path: 'team',
                name: 'app-feedback-master-team',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/master/team.vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'not-authorized',
            name: 'app-feedback-not-authorized',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/not-authorized.vue'),
            /* no children */
          },
  _definePage_default_37
  ),
          {
            path: 'preference',
            /* internal name: 'app-feedback-preference' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-preference',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/preference/index.vue'),
                /* no children */
              },
  _definePage_default_38
  ),
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'app-feedback-preference-id',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/preference/[id].vue'),
                /* no children */
              },
  _definePage_default_39
  )
            ],
          },
          {
            path: 'questionnaire',
            /* internal name: 'app-feedback-questionnaire' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-questionnaire',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/questionnaire/index.vue'),
                /* no children */
              },
  _definePage_default_40
  ),
  _mergeRouteRecord(
              {
                path: 'group',
                name: 'app-feedback-questionnaire-group',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/questionnaire/group.vue'),
                /* no children */
              },
  _definePage_default_41
  ),
              {
                path: 'question',
                name: 'app-feedback-questionnaire-question',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/questionnaire/question.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'second-page',
            name: 'app-feedback-second-page',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/second-page.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
          {
            path: 'sentiment',
            /* internal name: 'app-feedback-sentiment' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-sentiment',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/sentiment/index.vue'),
                /* no children */
              },
  _definePage_default_43
  )
            ],
          },
          {
            path: 'ticket-management',
            /* internal name: 'app-feedback-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-ticket-management',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_44
  ),
  _mergeRouteRecord(
              {
                path: 'board',
                name: 'app-feedback-ticket-management-board',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/board.vue'),
                /* no children */
              },
  _definePage_default_45
  ),
  _mergeRouteRecord(
              {
                path: 'compliment',
                name: 'app-feedback-ticket-management-compliment',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/ticket-management/compliment.vue'),
                /* no children */
              },
  _definePage_default_46
  )
            ],
          },
          {
            path: 'utility',
            /* internal name: 'app-feedback-utility' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'qrcode',
                name: 'app-feedback-utility-qrcode',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/feedback/utility/qrcode.vue'),
                /* no children */
              },
  _definePage_default_47
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'ForgotPassword',
        name: 'app-forgot-password',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/ForgotPassword.vue'),
        /* no children */
      },
  _definePage_default_48
  ),
      {
        path: 'global',
        /* internal name: 'app-global' */
        /* no component */
        children: [
          {
            path: 'config',
            /* internal name: 'app-global-config' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-config',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/config/index.vue'),
                /* no children */
              },
  _definePage_default_49
  ),
              {
                path: 'config',
                name: 'app-global-config-config',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/config/config.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'escalation',
            /* internal name: 'app-global-escalation' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-escalation',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/escalation/index.vue'),
                /* no children */
              },
  _definePage_default_50
  ),
              {
                path: 'create-update',
                name: 'app-global-escalation-create-update',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/escalation/create-update.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'holiday-calender',
            /* internal name: 'app-global-holiday-calender' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-holiday-calender',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/holiday-calender/index.vue'),
                /* no children */
              },
  _definePage_default_51
  )
            ],
          },
          {
            path: 'master',
            /* internal name: 'app-global-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'department',
                name: 'app-global-master-department',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/department.vue'),
                /* no children */
              },
  _definePage_default_52
  ),
  _mergeRouteRecord(
              {
                path: 'location',
                name: 'app-global-master-location',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/location.vue'),
                /* no children */
              },
  _definePage_default_53
  ),
  _mergeRouteRecord(
              {
                path: 'location-type',
                name: 'app-global-master-location-type',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/location-type.vue'),
                /* no children */
              },
  _definePage_default_54
  ),
  _mergeRouteRecord(
              {
                path: 'unit',
                name: 'app-global-master-unit',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/master/unit.vue'),
                /* no children */
              },
  _definePage_default_55
  )
            ],
          },
          {
            path: 'notification-configuration',
            /* internal name: 'app-global-notification-configuration' */
            /* no component */
            children: [
              {
                path: '',
                name: 'app-global-notification-configuration',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/notification-configuration/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'template-x',
            /* internal name: 'app-global-template-x' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'email',
                name: 'app-global-template-xemail',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/email.vue'),
                /* no children */
              },
  _definePage_default_56
  ),
  _mergeRouteRecord(
              {
                path: 'sms',
                name: 'app-global-template-xsms',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/sms.vue'),
                /* no children */
              },
  _definePage_default_57
  ),
  _mergeRouteRecord(
              {
                path: 'whatsapp',
                name: 'app-global-template-xwhatsapp',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/template-x/whatsapp.vue'),
                /* no children */
              },
  _definePage_default_58
  )
            ],
          },
          {
            path: 'users',
            /* internal name: 'app-global-users' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-users',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/users/index.vue'),
                /* no children */
              },
  _definePage_default_59
  ),
              {
                path: 'user',
                name: 'app-global-users-user',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/global/users/user.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'incident',
        /* internal name: 'app-incident' */
        /* no component */
        children: [
          {
            path: 'audit',
            /* internal name: 'app-incident-audit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-incident-audit',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/audit/index.vue'),
                /* no children */
              },
  _definePage_default_60
  ),
              {
                path: 'entry',
                name: 'app-incident-audit-entry',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/audit/entry.vue'),
                /* no children */
              },
              {
                path: 'view',
                name: 'app-incident-audit-view',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/audit/view.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'capa',
            /* internal name: 'app-incident-capa' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-incident-capa',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/capa/index.vue'),
                /* no children */
              },
  _definePage_default_61
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'capa-calender',
            name: 'app-incident-capa-calender',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/capa-calender.vue'),
            /* no children */
          },
  _definePage_default_62
  ),
          {
            path: 'dashboard',
            /* internal name: 'app-incident-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-incident-dashboard',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_63
  )
            ],
          },
          {
            path: 'incident',
            /* internal name: 'app-incident-incident' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-incident-incident',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/index.vue'),
                /* no children */
              },
  _definePage_default_64
  ),
              {
                path: 'entry',
                /* internal name: 'app-incident-incident-entry' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-incident-incident-entry',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/entry/index.vue'),
                    /* no children */
                  },
  _definePage_default_65
  ),
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-incident-incident-entry-view',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/incident/entry/view.vue'),
                    /* no children */
                  },
  _definePage_default_66
  )
                ],
              }
            ],
          },
          {
            path: 'master',
            /* internal name: 'app-incident-master' */
            /* no component */
            children: [
              {
                path: 'audit',
                /* internal name: 'app-incident-master-audit' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-incident-master-audit',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/audit/index.vue'),
                    /* no children */
                  },
  _definePage_default_67
  ),
                  {
                    path: 'questionnaire',
                    name: 'app-incident-master-audit-questionnaire',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/audit/questionnaire.vue'),
                    /* no children */
                  }
                ],
              },
  _mergeRouteRecord(
              {
                path: 'category',
                name: 'app-incident-master-category',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/category.vue'),
                /* no children */
              },
  _definePage_default_68
  ),
  _mergeRouteRecord(
              {
                path: 'contributory-factor',
                name: 'app-incident-master-contributory-factor',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/contributory-factor.vue'),
                /* no children */
              },
  _definePage_default_69
  ),
  _mergeRouteRecord(
              {
                path: 'fishbone-category',
                name: 'app-incident-master-fishbone-category',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/fishbone-category.vue'),
                /* no children */
              },
  _definePage_default_70
  ),
  _mergeRouteRecord(
              {
                path: 'incident-category',
                name: 'app-incident-master-incident-category',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/incident-category.vue'),
                /* no children */
              },
  _definePage_default_71
  ),
  _mergeRouteRecord(
              {
                path: 'investigation-group',
                name: 'app-incident-master-investigation-group',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/investigation-group.vue'),
                /* no children */
              },
  _definePage_default_72
  ),
              {
                path: 'question',
                /* internal name: 'app-incident-master-question' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-incident-master-question',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/question/index.vue'),
                    /* no children */
                  },
  _definePage_default_73
  ),
  _mergeRouteRecord(
                  {
                    path: 'entry',
                    name: 'app-incident-master-question-entry',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/question/entry.vue'),
                    /* no children */
                  },
  _definePage_default_74
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'tag',
                name: 'app-incident-master-tag',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/tag.vue'),
                /* no children */
              },
  _definePage_default_75
  ),
  _mergeRouteRecord(
              {
                path: 'type',
                name: 'app-incident-master-type',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/master/type.vue'),
                /* no children */
              },
  _definePage_default_76
  )
            ],
          },
          {
            path: 'rca',
            /* internal name: 'app-incident-rca' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-incident-rca',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/rca/index.vue'),
                /* no children */
              },
  _definePage_default_77
  ),
              {
                path: 'investigation',
                /* internal name: 'app-incident-rca-investigation' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'app-incident-rca-investigation',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/rca/investigation/index.vue'),
                    /* no children */
                  }
                ],
              },
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'app-incident-rca-view',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/incident/rca/view.vue'),
                /* no children */
              },
  _definePage_default_78
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'app-login',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/login.vue'),
        /* no children */
      },
  _definePage_default_79
  ),
  _mergeRouteRecord(
      {
        path: 'not-authorized',
        name: 'app-not-authorized',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/not-authorized.vue'),
        /* no children */
      },
  _definePage_default_80
  ),
  _mergeRouteRecord(
      {
        path: 'panel',
        name: 'app-panel',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/panel.vue'),
        /* no children */
      },
  _definePage_default_81
  ),
  _mergeRouteRecord(
      {
        path: 'ResetPassword',
        name: 'app-reset-password',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/ResetPassword.vue'),
        /* no children */
      },
  _definePage_default_82
  ),
      {
        path: 'service-desk',
        /* internal name: 'app-service-desk' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'dashboard',
            name: 'app-service-desk-dashboard',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/dashboard.vue'),
            /* no children */
          },
  _definePage_default_83
  ),
          {
            path: 'master',
            /* internal name: 'app-service-desk-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'task',
                name: 'app-service-desk-master-task',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/master/task.vue'),
                /* no children */
              },
  _definePage_default_84
  )
            ],
          },
          {
            path: 'ticket-management',
            /* internal name: 'app-service-desk-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-service-desk-ticket-management',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_85
  )
            ],
          },
          {
            path: 'utility',
            /* internal name: 'app-service-desk-utility' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'qrcode',
                name: 'app-service-desk-utility-qrcode',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/service-desk/utility/qrcode.vue'),
                /* no children */
              },
  _definePage_default_86
  )
            ],
          }
        ],
      },
      {
        path: 'survey',
        /* internal name: 'app-survey' */
        /* no component */
        children: [
          {
            path: 'collection',
            /* internal name: 'app-survey-collection' */
            /* no component */
            children: [
              {
                path: 'customer',
                /* internal name: 'app-survey-collection-customer' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-survey-collection-customer',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/customer/index.vue'),
                    /* no children */
                  },
  _definePage_default_87
  ),
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-survey-collection-customer-view',
                    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/customer/view.vue'),
                    /* no children */
                  },
  _definePage_default_88
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'app-survey-collection-view',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/collection/view.vue'),
                /* no children */
              },
  _definePage_default_89
  )
            ],
          },
          {
            path: 'customer',
            /* internal name: 'app-survey-customer' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-customer',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/index.vue'),
                /* no children */
              },
  _definePage_default_90
  ),
  _mergeRouteRecord(
              {
                path: 'analytics',
                name: 'app-survey-customer-analytics',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/analytics.vue'),
                /* no children */
              },
  _definePage_default_91
  ),
  _mergeRouteRecord(
              {
                path: 'setup',
                name: 'app-survey-customer-setup',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/setup.vue'),
                /* no children */
              },
  _definePage_default_92
  ),
  _mergeRouteRecord(
              {
                path: 'subscriptions',
                name: 'app-survey-customer-subscriptions',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/customer/subscriptions.vue'),
                /* no children */
              },
  _definePage_default_93
  )
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'app-survey-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-dashboard',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_94
  )
            ],
          },
          {
            path: 'employee',
            /* internal name: 'app-survey-employee' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-employee',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/employee/index.vue'),
                /* no children */
              },
  _definePage_default_95
  ),
              {
                path: 'setup',
                name: 'app-survey-employee-setup',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/employee/setup.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'event',
            /* internal name: 'app-survey-event' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-event',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/event/index.vue'),
                /* no children */
              },
  _definePage_default_96
  ),
              {
                path: 'setup',
                name: 'app-survey-event-setup',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/event/setup.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'ticket-management',
            /* internal name: 'app-survey-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-ticket-management',
                component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/survey/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_97
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'two-step',
        name: 'app-two-step',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/app/two-step.vue'),
        /* no children */
      },
  _definePage_default_98
  )
    ],
  },
  {
    path: '/care-visit',
    /* internal name: 'care-visit' */
    /* no component */
    children: [
      {
        path: 'visitor',
        /* internal name: 'care-visit-visitor' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'pass',
            name: 'care-visit-visitor-pass',
            component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/care-visit/visitor/pass.vue'),
            /* no children */
          },
  _definePage_default_99
  )
        ],
      }
    ],
  },
  {
    path: '/ComingSoon',
    name: 'coming-soon',
    component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/ComingSoon.vue'),
    /* no children */
  },
  {
    path: '/documentation',
    /* internal name: 'documentation' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':slug(.*)',
        name: 'documentation$slug',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/documentation/[...slug].vue'),
        /* no children */
      },
  _definePage_default_100
  )
    ],
  },
  {
    path: '/feedback-collect',
    /* internal name: 'feedback-collect' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'feedback-collect',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/feedback-collect/index.vue'),
        /* no children */
      },
  _definePage_default_101
  )
    ],
  },
  {
    path: '/service-desk',
    /* internal name: 'service-desk' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'service-desk',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/service-desk/index.vue'),
        /* no children */
      },
  _definePage_default_102
  ),
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'service-desk-chat',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/service-desk/chat.vue'),
        /* no children */
      },
  _definePage_default_103
  )
    ],
  },
  {
    path: '/survey-collect',
    /* internal name: 'survey-collect' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'survey-collect',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/survey-collect/index.vue'),
        /* no children */
      },
  _definePage_default_104
  )
    ],
  },
  {
    path: '/visitor-pass',
    /* internal name: 'visitor-pass' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':code',
        name: 'visitor-pass-code',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/visitor-pass/[code].vue'),
        /* no children */
      },
  _definePage_default_105
  )
    ],
  },
  {
    path: '/visitor-registration',
    /* internal name: 'visitor-registration' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'visitor-registration',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/visitor-registration/index.vue'),
        /* no children */
      },
  _definePage_default_106
  )
    ],
  },
  {
    path: '/wecarexm-ai',
    /* internal name: 'wecarexm-ai' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'wecarexm-ai',
        component: () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/pages/wecarexm-ai/index.vue'),
        /* no children */
      },
  _definePage_default_107
  )
    ],
  }
]
